import ContentLoader from "react-content-loader";
type Props = {
  count?: number;
};

const SkeletonProductCart = ({ count = 1 }: Props) => {
  const bgColor = "#fbfbfb";
  const fgColor = "#ecebeb";

  const loaderItems = Array.from({ length: count }).map((_, index) => (
    <div className="row" key={index}>
      <div className="col-5 col-lg-2 col-sm-3">
        <ContentLoader
          width="100%"
          // viewBox="0 0 100% 60"
          backgroundColor={bgColor}
          foregroundColor={fgColor}
        >
          <rect x="10%" y="15%" rx="5" ry="5" width="80%" height="100" />
        </ContentLoader>
      </div>
      <div className="col-7 col-lg-10 col-sm-8">
        {/* <ContentLoader
          width={"100%"}
          viewBox="0 0 100% 60"
          backgroundColor={bgColor}
          foregroundColor={fgColor}
        >
          <rect x="0" y="25%" rx="4" ry="4" width="90%" height="15" />
          <rect x="0" y="50%" rx="3" ry="3" width="70%" height="10" />
          <rect x="0" y="65%" rx="3" ry="3" width="60%" height="10" />
        </ContentLoader> */}
        <ContentLoader
          speed={2}
          backgroundColor={bgColor}
          foregroundColor={fgColor}
          width="100%"
        >
          <rect x="0" y="20" rx="10" ry="10" width="90%" height="20" />
          <rect x="0" y="60" rx="10" ry="10" width="70%" height="15" />
          <rect x="0" y="80" rx="10" ry="10" width="60%" height="15" />
        </ContentLoader>
      </div>
    </div>
  ));
  return <>{loaderItems}</>;
};

export default SkeletonProductCart;
